<button mat-icon-button
  class="viewRow actionBtn"
  name="Link Datasource Node"
  [disabled]="disableLinkState"
  (click)="linkDatasourceNode(params)"
  [ngClass]="params.data?.isLinked ? 'linked' : 'unlinked'">
  <mat-icon>link</mat-icon>
</button>